/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import { useTheme } from 'react-jss'
import { styles, cirleIconStyles } from './styles'

interface CircleImageProps {
    url: string
}
interface CircleProps {
    mWidth?: string
    marginRight?: string
    fontSize?: string
    borderWidth?: string
}

interface CircleIconProps {
    iconWidth?: string
    backgroundColor?: string
    borderColor?: string
    borderWidth?: string
}

interface CircleIcon2Props {
    width: string
    backgroundColor?: string
    withBorder?: boolean
    borderWidth?: string
}

// TODO Add extra icon (over) possibility - for ex. edit profile pic

const Circle: React.FC<CircleProps> = ({
    children,
    mWidth = '2.75rem',
    marginRight = '1rem',
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = styles({
        ...{ mWidth, customRight: marginRight },
        theme,
    })

    return <div className={classes.circle}>{children}</div>
}

const CircleText: React.FC<CircleProps> = ({
    children,
    fontSize = '1.125rem',
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = styles({
        ...{ fontSize },
        theme,
    })

    return <div className={classes.text}>{children}</div>
}

const CircleIcon: React.FC<CircleIconProps> = ({
    children,
    iconWidth,
    backgroundColor,
    borderColor,
    borderWidth,
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = styles({
        ...{ iconWidth, backgroundColor, borderColor, borderWidth },
        theme,
    })

    return <div className={classes.iconContainer}>{children}</div>
}

const CircleIcon2: React.FC<CircleIcon2Props> = ({
    width,
    backgroundColor,
    children,
    withBorder,
    borderWidth,
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = cirleIconStyles({
        ...{
            width,
            backgroundColor,
            withBorder,
            borderWidth,
        },
        theme,
    })

    return <span className={classes.iconContainer}>{children}</span>
}

const CircleImage: React.FC<CircleImageProps> = ({ url }) => {
    const theme = useTheme<Jss.Theme>()
    const classes = styles({
        ...{},
        theme,
    })

    return (
        <div className={classes.image}>
            <img src={url} alt="profileimage" />
        </div>
    )
}

Circle.defaultProps = {
    mWidth: '2.75rem',
    marginRight: '1rem',
}

CircleIcon2.defaultProps = {
    borderWidth: '3px',
}

export { Circle, CircleText, CircleImage, CircleIcon, CircleIcon2 }
